var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16.6667,
    height: 16.6667,
    viewBox: "0 0 16.6667 16.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3333 7.35C12.8731 7.35 12.5 7.7231 12.5 8.18333V14.1667C12.5 14.6269 12.1269 15 11.6667 15H2.5C2.03976 15 1.66667 14.6269 1.66667 14.1667V5C1.66667 4.53976 2.03976 4.16667 2.5 4.16667H8.48333C8.94357 4.16667 9.31667 3.79357 9.31667 3.33333C9.31667 2.8731 8.94357 2.5 8.48333 2.5H2.5C1.11929 2.5 0 3.61929 0 5V14.1667C0 15.5474 1.11929 16.6667 2.5 16.6667H11.6667C13.0474 16.6667 14.1667 15.5474 14.1667 14.1667V8.18333C14.1667 7.7231 13.7936 7.35 13.3333 7.35ZM16.6 0.516667C16.5154 0.313042 16.3536 0.151229 16.15 0.0666667C16.0498 0.0239659 15.9422 0.00131666 15.8333 0H10.8333C10.3731 0 10 0.373096 10 0.833333C10 1.29357 10.3731 1.66667 10.8333 1.66667H13.825L5.24167 10.2417C5.08391 10.3981 4.99517 10.6111 4.99517 10.8333C4.99517 11.0555 5.08391 11.2685 5.24167 11.425C5.39814 11.5828 5.61114 11.6715 5.83333 11.6715C6.05553 11.6715 6.26853 11.5828 6.425 11.425L15 2.84167V5.83333C15 6.29357 15.3731 6.66667 15.8333 6.66667C16.2936 6.66667 16.6667 6.29357 16.6667 5.83333V0.833333C16.6654 0.724436 16.6427 0.616852 16.6 0.516667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.409c8bc14ed66d0a3df7925464a7a3d7.svg";
export { ForwardRef as ReactComponent };